import { z } from 'zod'

export const phoneSchema = z.object({
  id: z.number().nullish(),
  telefone: z.string().nullish(),
  descricao: z.string().nullish(),
})

export type PhoneType = z.infer<typeof phoneSchema>

export const phoneInit: PhoneType = {
  telefone: '',
  descricao: '',
}
